<template>
  <div>页面未找到</div>
</template>

<script>
export default {
  name: "NotFound",
};
</script>

<style scoped></style>
